var ModalSize;

(function (ModalSize) {
  ModalSize["Custom"] = "MODAL/CUSTOM";
  ModalSize["FullScreen"] = "MODAL/FULL_SCREEN";
  ModalSize["XxLarge"] = "MODAL/XX_LARGE";
  ModalSize["XLarge"] = "MODAL/X_LARGE";
  ModalSize["Large"] = "MODAL/LARGE";
  ModalSize["Medium"] = "MODAL/MEDIUM";
  ModalSize["Small"] = "MODAL/SMALL";
})(ModalSize || (ModalSize = {}));

var ModalCloseButtonSide;

(function (ModalCloseButtonSide) {
  ModalCloseButtonSide["Leading"] = "Leading";
  ModalCloseButtonSide["Trailing"] = "Trailing";
})(ModalCloseButtonSide || (ModalCloseButtonSide = {}));

export { ModalCloseButtonSide, ModalSize };
